<template>
  <v-container
    id="raccoltapunti"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
    }"
    fluid
    tag="section"
    style="height: calc(100% - 110px)"
  >
    <base-material-card
      icon="mdi-newspaper-plus"
      class="px-5 py-3"
      width="100%"
    >
      <v-row>
        <v-col
          cols="12"
        >
          <div class="text-center">
            <span class="text-h3 font-weight-light">Punti Acquisiti</span><br>
            <v-progress-circular

              :rotate="180"
              :size="100"
              :width="15"
              :value="(puntiraccolti * 100)/puntiSblocco"
              color="pink"
            >
              {{ puntiraccolti }} pt.
            </v-progress-circular>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            mobile-breakpoint="0"

            disable-pagination
            hide-default-footer
            dense
            :items="tabdata"
            :headers="cheaders"
            item-key="id"
          >
            <template
              v-slot:item.codcli="{item}"
            >
              {{ acquirente(item.codcli).ragsoc }} {{ acquirente(item.codcli).indiri_1 }} <br>
              {{ acquirente(item.codcli).indiri_2 }} {{ acquirente(item.codcli).locali }}
            </template>
            <template
              v-slot:item.progre="{item}"
            >
              <template v-if="item.progre>0 && !item.description">
                Acquisto <b>{{ item.linea }}</b>, nr.attribuito: {{ item.progre }}
              </template>
              <template v-else>
                <b>{{ item.description }}</b>
              </template>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>

    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'
  import Config from '@/config.js'

  export default {
    name: 'Raccoltapunti',
    components: {

    },
    data () {
      return {
        loading: false,
        puntivendita: [],
        puntiSblocco: Config.puntiSblocco,
        puntiraccolti: 0,
        tabdata: [],
        headers: [
          { text: 'Punti', value: 'punti', align: 'right text-caption' },
          { text: 'Descrizione', value: 'progre', align: 'left text-caption' },
          { text: 'Linea', value: 'linea', align: 'left text-caption' },
          { text: 'Data', value: 'created_at', align: 'left text-caption' },
          { text: 'Acquirente', value: 'codcli', align: 'left text-caption' },

        ],
      }
    },
    computed: {
      ...mapState(['auth']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      cheaders () {
        console.log('flagGroup', this.auth.flagGroup)
        if (this.auth.flagGroup === true) {
          return this.headers
        }
        return this.headers.filter(itm => itm.value !== 'codcli')
      },
    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => {
            this.showBackOnline = false
          }, 1000)
        }
      },
    },
    mounted () {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
      var codsog = this.auth.userinfo.codsog
      var coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
      var codcli = `${codsog}${coddes}`
      console.log('analisi codcli', codcli)
      this.get_puntiDisponibili(codcli)
      this.get_dettaglio_punti(codcli)
      this.get_destinatari(codsog)
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {

      swipe (direction) {
        if (direction === 'Left') {
          this.step++
        } else {
          this.step--
        }
      },
      updateOnlineStatus (e) {
        const { type } = e
        this.onLine = type === 'online'
      },
      get_destinatari (codsog) {
        this.loading = true
        engine.get_destinatari(codsog)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.puntivendita = result.data
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },
      get_dettaglio_punti (codcli) {
        this.loading = true
        engine.get_dettaglio_punti(codcli)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.tabdata = result.data
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },
      get_puntiDisponibili (codcli) {
        this.loading = true
        engine.get_puntiDisponibili(codcli)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.puntiraccolti = parseInt(result.data.totpunti)
            this.loading = false
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },
      acquirente (codcli) {
        const coddes = codcli.slice(6)
        var puntovendita = this.puntivendita.filter(itm => parseInt(itm.coddes) === parseInt(coddes))
        return puntovendita[0]
      },
    },

  }
</script>
